import React from "react"
import {
  Chart as ChartJS,
  CategoryScale,
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import { Line } from "react-chartjs-2"
import PropTypes from "prop-types"
import "chartjs-adapter-luxon"

ChartJS.register(
  CategoryScale,
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

const TelematicsLineChart = ({ data, title, xLabel, yLabel }) => {
  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: title,
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        type: "time", // Set the x-axis type to 'time'
        time: {
          tooltipFormat: "HH:mm", // Tooltip format
        },
        title: {
          display: true,
          text: xLabel,
        },
      },
      y: {
        title: {
          display: true,
          text: yLabel,
        },
      },
    },
  }

  const input = {
    labels: data.map((d) => d?.x),
    datasets: [
      {
        label: "Speed",
        data: data.map((d) => d?.y), // Speed values (y-axis data points)
        fill: false,
        borderColor: "rgba(75, 192, 192, 1)",
        tension: 0.4, // Set the tension for smooth curve
        borderWidth: 2, // Adjust the line thickness as needed
        pointStyle: false, // Use 'rectRounded' for rounded data points or 'circle' for circles
        pointRadius: 10, // Hide data points
      },
    ],
  }
  return <Line options={options} data={input} />
}

TelematicsLineChart.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  unit: PropTypes.string, // The unit of measurement e.g. km/h
  xLabel: PropTypes.string,
  yLabel: PropTypes.string,
  strokeColor: PropTypes.string, // the color of the line on the chart
}

export default TelematicsLineChart
